;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { JwtUser } from '@workspace/ui/types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface AuthState {
  accessToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  user: JwtUser | null;
  permissionMap: Record<string, number> | null;
  isPermissionMapLoaded: boolean;

  setIsLoading: (loading: boolean) => void;
  setAuthenticated: (auth: boolean) => void;
  setAccessToken: (token: string | null) => void;
  setUser: (user: JwtUser | null) => void;
  removePermission: (permission: number) => void;
  setPermissionMap: (map: Record<string, number>) => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      isLoading: true,
      isAuthenticated: false,
      accessToken: null,
      user: null,
      permissionMap: null,
      isPermissionMapLoaded: false,

      setIsLoading: (loading: boolean) => set({ isLoading: loading }, undefined, 'setIsLoading'),
      setAccessToken: (token: string | null) =>
        set({ accessToken: token }, undefined, 'setAccessToken'),
      setAuthenticated: (auth: boolean) =>
        set({ isAuthenticated: auth }, undefined, 'setAuthenticated'),
      setUser: (user: JwtUser | null) => set({ user }, undefined, 'setUser'),
      removePermission: (permission: number) =>
        set(
          (state) => {
            if (!state.user?.permissions) return state;

            return {
              user: {
                ...state.user,
                permissions: state.user.permissions.filter((p) => p !== permission),
              },
            };
          },
          undefined,
          'removePermission'
        ),
      setPermissionMap: (map: Record<string, number>) =>
        set({ permissionMap: map, isPermissionMapLoaded: true }, undefined, 'setPermissionMap'),
    }),
    {
      enabled: process.env.NODE_ENV === 'development',
      name: 'auth-store',
    }
  )
);
